import { ACTIVITY_CONTENT } from './activity.js';
import { INITIATIVE_CONTENT } from './initiative.js';
import { PARENT_PORTFOLIO_CONTENT } from './parent-portfolio.js';
import { PORTFOLIO_CONTENT } from './portfolio.js';
import { PROJECT_CONTENT } from './project.js';

export const CHANGE_SYNC_CONTENT = {
  ...INITIATIVE_CONTENT,
  ...PARENT_PORTFOLIO_CONTENT,
  ...PORTFOLIO_CONTENT,
  ...ACTIVITY_CONTENT,
  ...PROJECT_CONTENT,
};
